export default {
    "transactions_title": "Resumen de Transacción",
    "transactions_customer": "Cliente",
    "transactions_status": "Estado",
    "transactions_error": "Error",
    "transactions_refresh": "Actualizar",
}